export default __webpack_public_path__ + "static/media/user.771e186c.svg";